/** Maximum payload size in bytes for each EMRG tier. */
export const TIER_MAX_BYTES = { 0: 51, 1: 115, 2: 222 } as const;

/** "EMRG" ASCII bytes — first 4 bytes of every EMRG payload header. */
export const SCHEMA_ASCII = [0x45, 0x4D, 0x52, 0x47] as const;

/**
 * Base epoch for timestamps: 2020-01-01T00:00:00 UTC in Unix seconds.
 * Payload timestamps are encoded as `(unixSeconds - BASE_EPOCH)` so they
 * fit in a uint32 without losing seconds-level precision.
 */
export const BASE_EPOCH = 1577836800;

/** Largest valid device ID: 2^24 - 1 (uint24, 3 bytes on the wire). */
export const MAX_DEVICE_ID = 16777215;

/** Human-readable tier names. */
export const TIER_NAMES = { 0: 'NANO', 1: 'MICRO', 2: 'FULL' } as const;
